import { ThemeEnum } from '../../../../utils/enums';
import { IStepProps } from './Step/Step.types';

export const SnakeStepsData: IStepProps[] = [
  {
    iconName: {
      [ThemeEnum.Basic]: 'play',
      [ThemeEnum.Light]: 'playLight',
      [ThemeEnum.Dark]: 'playDark',
    },
    text: 'Получи бесплатную консультацию',
  },
  {
    iconName: {
      [ThemeEnum.Basic]: 'chart',
      [ThemeEnum.Light]: 'chartLight',
      [ThemeEnum.Dark]: 'chartDark',
    },
    text: 'Определи свою нишу',
  },
  {
    iconName: {
      [ThemeEnum.Basic]: 'document',
      [ThemeEnum.Light]: 'documentLight',
      [ThemeEnum.Dark]: 'documentDark',
    },
    text: 'Составь план достижения целей',
  },
  {
    iconName: {
      [ThemeEnum.Basic]: 'work',
      [ThemeEnum.Light]: 'workLight',
      [ThemeEnum.Dark]: 'workDark',
    },
    text: 'Открой свой бизнес',
  },
];
